import isEmpty from 'lodash/isEmpty'
import http from 'core/pkg/http'

export default {
  init(options = {}, services) {
    const httpInstance = http.init(Object.assign({}, {
      baseURL: (options && options.baseURL) ? options.baseURL : '',
      headers: (options && options.contentType ? options.contentType : {
        Accept: 'application/json',
        'Content-Type': 'application/json'
      }),
      validateStatus: status => {
        return status >= 200 && status < 300
      },
      transformRequest: [
        (data, headers) => {
          if (headers['Content-Type'] !== 'multipart/form-data') {
            let _data = services.utils.transform.camelToSnake(data)

            _data = JSON.stringify(_data)

            return _data
          }

          return data
        }
      ],
      transformResponse: [
        data => {
          if (isEmpty(data)) {
            return data
          }

          let _data = JSON.parse(data)
          _data = services.utils.transform.snakeToCamel(_data)

          return _data
        }
      ]
    }, options))

    return httpInstance
  }
}
